import * as React from "react";
export const useSelectedIndex = <T extends { id: string }>(
  galleryButtons: T[],
  selectedId: string | undefined
) => {
  const selectedIndex = React.useMemo(() => {
    return galleryButtons.findIndex((item) => item.id === selectedId);
  }, [galleryButtons, selectedId]);

  return selectedIndex;
};
